import { Button, Drawer, Layout, Typography } from 'antd';
import {FC, JSX, ReactNode, useState} from 'react';
import { useLocation } from 'react-router-dom';
import { MenuOutlined } from '@ant-design/icons';
import cn from 'classnames';

import { ProfileButton, Footer } from 'componets/ui';
import MainMenu from 'pages/Account/MainMenu';
import { AccountLayoutLogoLink } from '../AccountLayoutLogoLink';
import { AccountReferralModal } from '../AccountReferralModal';
import { AccountLayoutNewsDropdown } from '../AссountLayoutNewsDropdown';
import { AccountLayoutContentAlerts } from './AccountLayoutContentAlerts';

import { Paths } from 'utils/constants';

import { useAppSelector, useTranslate } from 'hooks';

import { selectIsAdmin, selectUser } from 'selectors';

import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
import { ReactComponent as GiftIcon } from 'assets/icons/gift.svg';

import styles from '../index.module.scss';

type AccountLayoutContentProps = {
	title: string | ReactNode | JSX.Element;
	children: ReactNode;
	isGreeting?: boolean;
};

export const AccountLayoutContent: FC<AccountLayoutContentProps> = ({
	title,
	children,
	isGreeting,
}) => {
	const user = useAppSelector(selectUser);
	const isAdmin = useAppSelector(selectIsAdmin);

	const { getBonusText, helloText } = useTranslate([
		'getBonusText',
		'helloText',
		'allNewsText',
	]);

	const location = useLocation();

	const isOverview = location.pathname === Paths.OVERVIEW;

	const [isOpen, setIsOpen] = useState(false);
	const [isOpenReferral, setIsOpenReferral] = useState(false);
	title = isGreeting ? (
			`${helloText} ${user.firstName} 👋`
		) : (
			title
		);

	return (
		<Layout>
			{isOverview && user.verificationStatus && <AccountLayoutContentAlerts />}

			<Layout.Header className={styles.header}>
				<div className={styles.headerContent}>
					<AccountLayoutLogoLink className={styles.wrapperMobile} />

					<Typography.Title
						level={4}
						className={cn(styles.nameTitle, { [styles.newsTitle]: title === 'newsItem' })}
					>
						{title}
					</Typography.Title>

					<div className={styles.user}>
						<AccountLayoutNewsDropdown unReadCount={user.news?.unreadCount} />

						<Button
							type="primary"
							className={cn(styles.bonus, { 'ant-btn-grey': isAdmin })}
							onClick={() => setIsOpenReferral(true)}
							aria-label="get a bonus button"
						>
							<GiftIcon />
							<span className={styles.bonusText}>{getBonusText}</span>
						</Button>

						<ProfileButton email={user.email} isAccount={true} />

						<div
							role="button"
							className={styles.button}
							onClick={() => {
								setIsOpen(true);
							}}
						>
							<MenuOutlined />
						</div>
					</div>
				</div>
				<div className={styles.headerContentMobile}>
					<Typography.Title
						level={4}
						className={cn(styles.nameTitle, { [styles.newsTitle]: title === 'newsItem' })}
					>
						{title}
					</Typography.Title>
				</div>
			</Layout.Header>
			<Layout.Content className={styles.content}>
				<div className={styles.contentWrapper}>{children}</div>
			</Layout.Content>

			<Footer />

			{isOpen && (
				<Drawer
					className="sidebar"
					width="100%"
					closable={false}
					onClose={() => setIsOpen(false)}
					open={isOpen}
					title={
						<div className="sidebar-title">
							<AccountLayoutLogoLink className="sidebar-link" />

							<Button
								onClick={() => setIsOpen(false)}
								className={styles.close}
								type="link"
								icon={<CloseIcon />}
							/>
						</div>
					}
				>
					<MainMenu
						onClose={() => {
							setIsOpen(false);
						}}
					/>
				</Drawer>
			)}

			<AccountReferralModal isOpen={isOpenReferral} onClose={() => setIsOpenReferral(false)} />
		</Layout>
	);
};
